module.exports = __webpack_public_path__ + "static/media/link_black.935133bd.svg";